import {get} from 'lodash';

export default (data) => {

  const ctaArr = data.btCtasRep ? get(data, 'btCtasRep', []) : [];
  
  return {
    title: get(data, 'btHeading', null),
    content: get(data, 'btBody', null),
    ctas: ctaArr.map(item => {
      return {
        bg: get(item, 'btCtaColour', null),
        title: get(item, 'btCtaLink.title', null),
        href: get(item, 'btCtaLink.href', null)
      }
    })
  }

  return data
}